import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense } from "react";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";
export function lazyRoute(importer) {
    const LazyComponent = React.lazy(importer);
    const Wrapped = (props) => (_jsx(Suspense, { fallback: _jsx(LoadingSpinner, {}), children: _jsx(LazyComponent, { ...props }) }));
    return Wrapped;
}
